import { toast } from 'sonner';

import { useModal } from '@/hooks';
import { toastError } from '@/utils';

import { useCreateStrengthMutation } from '../../../../features/slice/products/strength/strength-api-slice';
import { StrengthForm } from '../strength-form.component';

export const CreateStrength = () => {
    const [createStrength, { isLoading }] = useCreateStrengthMutation();
    const { closeModal } = useModal();

    const handleSubmit = async (values: { name: string }) => {
        try {
            await createStrength(values).unwrap();
            toast.success('Strength has been created');
            closeModal();
        } catch (error) {
            toastError(
                error,
                'CreateStrength: handleSubmit -> Failed to create strength.',
            );
        }
    };

    return (
        <StrengthForm
            initialValues={{ name: '' }}
            onSubmit={handleSubmit as any}
            isLoading={isLoading}
            title={'Create Strength'}
        />
    );
};
